<template>
    <v-card flat v-if="product">
        <v-layout>
            <v-flex xs4 md2>
                <v-img
                    v-if="product"
                    :src="product.images.default.small"
                    :lazy-src="product.images.default.placeholder"
                    :alt="product.images.default.image_description"
                    :aspect-ratio="1"
                />
            </v-flex>
            <v-flex xs8 md10 class="pl-2">
                <router-link :to="$product.getProductRouteConfig(product)">
                    {{ title }}
                </router-link>
                <div class="text-xs-right">
                    <p class="subheading">{{ 'from' | translation }} {{getProductPrice(product) | currency}}</p>
                    <div v-if="!hideAmountInput">
                        <amount-input 
                            class="d-inline-block"
                            :value.sync="quantity"
                            :product="product"
                            :current-merchant-id="Object.keys(product.merchant)[0]"
                            :current-product-id="product.id"
                            hide-tier-price-info
                        />
                    </div>
                    <basket-button
                        class="d-inline-flex"
                        :handler="addToBasket"
                        :product="product"
                        :current-merchant-id="Object.keys(product.merchant)[0]"
                        :amount-value="quantity"
                        :current-product-id="product.id"
                        @beforeAddToBasket="$emit('beforeAddToBasket', $event)"
                        @afterAddToBasket="$emit('afterAddToBasket', $event)"
                        :button-text="buttonText ? buttonText : 'Additional interesting'"
                        ref="basketButton"
                        :large="false"
                    ></basket-button>
                </div>
            </v-flex>
        </v-layout>

        <add-variant-to-basket-modal
            v-if="showVariant"
            v-model="showVariant"
            :product="product"
            :quantity="quantity"
            @beforeAddToBasket="$emit('beforeAddToBasket', $event)"
            @afterAddToBasket="$emit('afterAddToBasket', $event)"
            hide-amount-input="hideAmountInput"
        ></add-variant-to-basket-modal>
    </v-card>
</template>

<script>
    import AmountInput from './product-page/AmountInput';
    import {mapGetters} from 'vuex';
    import {eventManager} from '@breakmedia/prime-vue-event-manager';
    import AddVariantToBasketModal from './AddVariantToBasketModal';
    import BasketButton from '@breakmedia/prime-vue-product/src/product-page/BasketButton';

    export default {
        name: 'ProductThumbnailSmall',
        props: {
            product: {},
            target: {},
            hideAmountInput: Boolean,
            buttonText: String,
        },
        components: {
            AddVariantToBasketModal,
            AmountInput,
            BasketButton,
        },
        data() {
            return {
                quantity: 1,
                showVariant: false,
            };
        },
        created() {
            eventManager.$emit('productPreview', this.product, this.target);
        },
        computed: {
            title() {
                return this.getProductAttributeByLanguage(this.product, 'product.name');
            },
            ...mapGetters('Product', [
                'getProductAttributeByLanguage',
            ]),
        },
        methods: {
            addToBasket() {
                if(this.product.variantsIds && this.product.variantsIds.length){
                    this.showVariant = true;
                } else {
                    this.$refs.basketButton.buyProduct();
                }
            },
            getProductPrice(product) {
                const priceData = product.price || {};
                return priceData.original_price_inkl_vat;
            },
        },
    };
</script>

<style scoped>
    .amount-input {
        max-width: 140px;
    }
</style>